import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Button from 'src/common/components/ButtonDS22';
import useMobileNativeWebView from 'src/common/hooks/useMobileNativeWebView';
import ButtonGroup from '../../../common/components/ButtonGroup';
import Modal from '../../../common/components/Modal';

const {
  Header, Footer, Title, Description,
} = Modal;

export type LocationPromptProps = {
  modalOpen: boolean;
  closeModal: () => void;
  onAccept: () => void;
  onDecline: () => void;
};

const LocationPrompt: FC<LocationPromptProps> = ({
  modalOpen,
  closeModal,
  onAccept,
  onDecline,
}) => {
  const [t] = useTranslation('search-page');
  const { isMobileNativeWebView } = useMobileNativeWebView();
  if (isMobileNativeWebView) return null;
  return (
    <Modal
      modalOpen={modalOpen}
      label="locationPrompt"
      closeModal={closeModal}
      classNameModifier="locationModal"
    >
      <Header>
        <Title>
          {t('location-prompt--title')}
        </Title>
        <Description>{t('location-prompt--description')}</Description>
      </Header>
      <Footer>
        <ButtonGroup>
          <Button
            variant="tertiary"
            onClick={onDecline}
          >
            {t('location-prompt--cancel')}
          </Button>
          <Button
            onClick={onAccept}
          >
            {t('location-prompt--proceed')}
          </Button>
        </ButtonGroup>
      </Footer>
    </Modal>
  );
};

export default LocationPrompt;
